// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { Regex } from '../../_common/api/regex';
import Button from '../../_common/form/Button';
import Form from '../../_common/form/Form';
import HamLink from '../../_common/form/HamLink';
import Input from '../../_common/form/Input';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import { HamQuest } from '../../../App';
import { randomIntBetween } from '../../_common/api/utility';
import CheckBox from '../../_common/form/CheckBox';

const FormWrapper = styled(Form)`
    display: flex;
    flex-direction: column;
`
const Row = styled.div`
    display: flex;
    justify-content: flex-end;
`
const ForgotPW = styled(HamLink)`
    font-size: 0.6em;
`

const LogIn = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        logIn,
        guestLogIn,
        logOut
    } = useGlobalState();

    useEffect(() => {
        if (active_user.isGuestUser) logOut()
    }, [])

    if (active_user.isGuestUser) {
        return <Navigate to='/' replace />;
    }

    const createNewUser = () => {

        const firstNames = [
            "John", "Jane", "Michael", "Emily", "David", "Sarah",
            "James", "Laura", "Robert", "Lisa", "William", "Mary",
            "Joseph", "Linda", "Charles", "Karen", "Thomas", "Nancy",
            "Christopher", "Betty", "Daniel", "Margaret", "Matthew",
            "Sandra", "Anthony", "Ashley", "Mark", "Kimberly", "Paul",
            "Jessica", "Andrew", "Donna", "Joshua", "Carol", "Kenneth",
            "Michelle", "Kevin", "Dorothy", "Brian", "Amanda", "George",
            "Melissa", "Edward", "Deborah", "Ronald", "Stephanie",
            "Timothy", "Rebecca", "Jason", "Sharon"
        ];

        const lastNames = [
            "Smith", "Johnson", "Brown", "Williams", "Jones", "Miller",
            "Davis", "Garcia", "Rodriguez", "Martinez", "Hernandez",
            "Lopez", "Gonzalez", "Wilson", "Anderson", "Thomas", "Taylor",
            "Moore", "Jackson", "Martin", "Lee", "Perez", "Thompson",
            "White", "Harris", "Sanchez", "Clark", "Ramirez", "Lewis",
            "Robinson", "Walker", "Young", "Allen", "King", "Wright",
            "Scott", "Torres", "Nguyen", "Hill", "Flores", "Green",
            "Adams", "Nelson", "Baker", "Hall", "Rivera", "Campbell",
            "Mitchell", "Carter", "Roberts"
        ];

        const newUser = {
            firstName: firstNames[randomIntBetween(0, firstNames.length)],
            lastName: lastNames[randomIntBetween(0, lastNames.length)],
            birthdayMonth: randomIntBetween(1, 12),
            birthdayDay: randomIntBetween(1, 28),
            zipPostalCode: randomIntBetween(10000, 99999),
            cellPhoneNumber: `419${randomIntBetween(100, 999)}${randomIntBetween(1000, 9999)}`,
            password: 'Hamilton123$',
            referralCode: '',
            confirmEmail: true
        }

        newUser.email = `${newUser.firstName.charAt(0)}${newUser.lastName}+${randomIntBetween(10, 100)}@Hamilton.com`

        Modal.Show({
            title: 'Quick Signup',
            body: (
                <Form
                    inputs={{ ...newUser }}

                    onSubmit={e => HamQuest.post(QuestRoute.user.signUp, { ...e }, { captcha: window.siteKey })
                        .then(async () => {
                            await logIn({
                                email: newUser.email,
                                password: newUser.password
                            })
                                .then(() => Modal.Close())
                        })}
                    submitButton={`Create User ${newUser.firstName} ${newUser.lastName}`}
                >
                    <CheckBox
                        label='Confirm Email'
                        name='confirmEmail'
                    />
                    <Input
                        label='Referral'
                        name='referralCode'
                    />
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        validate={(e, setMsg, resolve) => {
                            const inputEmail = e;
                            if (e.match(Regex.match.email)) {
                                HamQuest.post(QuestRoute.validate.email, {
                                    email: e
                                })
                                    .then(e => {
                                        if (inputEmail === active_user.account?.email) {
                                            resolve(e);
                                            return;
                                        }
                                        if (!e) setMsg('Email is already associated with an account.');
                                        resolve(!e)
                                    })
                                    .catch((ex) => {
                                        setMsg(ex.blob);
                                    })
                            } else {
                                setMsg('Please enter a valid email.');
                                resolve(true)
                            }
                        }}
                        debounce={400}
                        required
                    />
                </Form>
            )
        })
    }

    const promptGuest = () => {
        Modal.Confirmation({
            title: 'Guest Log In',
            body: 'Logging in as a guest only allows access to viewing washes / clubs. Are you sure you wish to continue?',
            closeAfter: true,
        })
            .then(res => { if (res) guestLogIn() })
    }

    const handlePWReset = () => {
        Modal.Show({
            title: 'Enter your Email',
            body: (
                <Form
                    inputs={{
                        email: '',
                    }}
                    onSubmit={(e) => HamQuest
                        .getQuery(QuestRoute.user.forgotPassword, {
                            email: e.email
                        })
                        .then(() => {
                            Modal.Show({
                                title: 'Email Sent',
                                body: 'Password recovery email sent!',
                                type: 'success',
                            })
                        })
                        .catch(ex => {
                            Modal.Show({
                                type: 'error',
                                title: 'Failed to Email',
                                body: ex.blob || 'Something went wrong. Please try again.'
                            })
                        })
                    }
                    submitButton={`Send Password Reset`}
                    style={{ width: '80vw' }}
                >
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        validate={Regex.match.email}
                        required
                    />
                </Form>
            )
        })
    }

    return (
        <>
            <Card>
                <FormWrapper
                    inputs={{
                        email: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_ADMIN : '',
                        password: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_PW : '',
                        // email: '',
                        // password: '',
                        rememberMe: false,
                    }}
                    onSubmit={logIn}
                    submitButton='Sign In'
                    submittingButton='Signing In'
                >
                    <Row>
                        <ForgotPW onClick={handlePWReset}>Forgot Password?</ForgotPW>
                    </Row>
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        required
                    />
                    <Input
                        label='Password'
                        name='password'
                        type='password'
                        required
                    />
                    <Input type='submit'>Sign In</Input>
                    <Button to='/signUp'>Sign Up</Button>
                    <Button onClick={promptGuest} type='button'>Continue as Guest</Button>
                </FormWrapper>
                {process.env.REACT_APP_ENV === 'dev' && <Button onClick={createNewUser}>The Dallas Button</Button>}
            </Card>
        </>
    );
}

export default LogIn;


export const handlePWReset = () => {
    Modal.Show({
        title: 'Enter your Email',
        body: (
            <Form
                inputs={{
                    email: '',
                }}
                onSubmit={(e) => HamQuest
                    .getQuery(QuestRoute.user.forgotPassword, {
                        email: e.email
                    })
                    .then(() => {
                        Modal.Show({
                            title: 'Email Sent',
                            body: 'Password recovery email sent!',
                            type: 'success',
                        })
                    })
                    .catch(ex => {
                        Modal.Show({
                            type: 'error',
                            title: 'Failed to Email',
                            body: ex.blob || 'Something went wrong. Please try again.'
                        })
                    })
                }
                submitButton={`Send Password Reset`}
            >
                <Input
                    label='Email'
                    name='email'
                    type='email'
                    validate={Regex.match.email}
                    required
                />
            </Form>
        )
    })
} 
